/** The forms step's standard look: one form page, or the app's words for one that could not be read. Holds no rule. */
import { formFailure } from '@/pages/DetailsPage/FormStepScreen';

import { FormSheet, FormSheetFailure } from '../../ui/FormSheet';
import type { FormsStepRuntime } from './useFormsStep';
import { contract } from './contract';

export function FormsStepView({ actions, page, submit }: FormsStepRuntime) {
  const failure = formFailure({ isError: page.formsError != null, errorMessage: page.formsError }, page.formFailed, actions.back);
  if (failure?.kind === 'error') return <FormSheetFailure failure={failure} piece={contract} />;
  if (!page.form) return null;
  return (
    <FormSheet
      piece={contract}
      form={page.form}
      index={page.index}
      total={page.total}
      paymentAhead={page.paymentAhead}
      submitting={page.submitting}
      fieldErrors={page.fieldErrors}
      submitError={page.submitError}
      backLabel={page.backLabel}
      onBack={actions.back}
      backDisabled={page.backPending}
      onSubmit={submit}
      onSave={page.save}
    />
  );
}
